// Utility functions for cross-browser animation support

export const forceReflow = (element: HTMLElement): void => {
  // Force a reflow to ensure animations restart properly
  element.offsetHeight;
};

export const restartAnimation = (element: HTMLElement): void => {
  // Stop animation
  element.style.animation = 'none';

  // Force reflow
  forceReflow(element);

  // Restart animation
  element.style.animation = '';
};

export const isSafari = (): boolean => {
  if (typeof window === 'undefined') return false;

  const userAgent = window.navigator.userAgent;
  return /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
};

export const isChrome = (): boolean => {
  if (typeof window === 'undefined') return false;

  const userAgent = window.navigator.userAgent;
  return /Chrome/.test(userAgent) && !/Edge/.test(userAgent);
};

export const isFirefox = (): boolean => {
  if (typeof window === 'undefined') return false;

  const userAgent = window.navigator.userAgent;
  return /Firefox/.test(userAgent);
};
